import * as React from "react";
import {useState} from "react";
import {IconButton} from "@material-ui/core";

export interface ISidebarNavigation {
  onNextClick: (itemPosition: number) => Promise<void>
  onPrevClick: (itemPosition: number) => Promise<void>
  totalItems: number
  initialPage?: number
}

const INITIAL_PAGE = 1

export const SidebarNavigation = ({
  onNextClick,
  totalItems,
  onPrevClick,
  initialPage
}: ISidebarNavigation) => {
  const [currentPosition, setCurrentPosition] = useState(initialPage ?? INITIAL_PAGE)

  const handleNextPage = async () => {
    const newPosition = currentPosition + 1

    if (newPosition > totalItems) {
      return
    }

    try {
      await onNextClick(newPosition)
      setCurrentPosition(newPosition)
    } catch (e) {
      // nic nie rób, obsłużone w akcjach
    }
  }

  const handlePrevPage = async () => {
    const newPosition = currentPosition - 1
    if (newPosition < INITIAL_PAGE) {
      return
    }

    try {
      await onPrevClick(newPosition)
      setCurrentPosition(newPosition)
    } catch (e) {
      // nic nie rób, obsłużone w akcjach
    }
  }

  return (
    <div className="sidebar__navigation">
      <IconButton
        className="sidebar__nav-button"
        onClick={handlePrevPage}
        disabled={currentPosition === INITIAL_PAGE}
        disableRipple
      >
        <img src="/images/icons/chevron_left.svg"/>
      </IconButton>
      <span>{currentPosition}/{totalItems}</span>
      <IconButton
        className="sidebar__nav-button"
        onClick={handleNextPage}
        disabled={currentPosition === totalItems}
        disableRipple
      >
        <img src="/images/icons/chevron_right.svg"/>
      </IconButton>
    </div>
  );
}

export default SidebarNavigation



// WEBPACK FOOTER //
// ./src/components/Layout/SidebarNavigation/SidebarNavigation.Component.tsx